import { InjectionToken } from '@angular/core';


export const defaultErrors = {
    required: (error) => `Campo obrigatório`,
    minlength: ({ requiredLength, actualLength }) => `Informe ao menos ${requiredLength} caracteres`,
    maxlength: ({ requiredLength, actualLength }) => `O máximo de caracteres é de ${requiredLength}`,
    email: (error) => `E-mail inválido`,
    cpf: (error) => `CPF Inválido`,
    telefone: (error) => `Telefone Inválido`,
    cnpj: (error) => `CNPJ Inválido`,
    nullValue: (error) => `Campo Obrigatório`,
    ngbDate: (error) => `${error.requiredAfter ? 'A data deve ser menor que ' + error.requiredAfter.day + '/' + error.requiredAfter.month + '/' + error.requiredAfter.year : error.requiredBefore ? 'A data deve ser maior que ' + error.requiredAfter.day + '/' + error.requiredAfter.month + '/' + error.requiredAfter.year : 'Data Inválida'}`,
    contrato: (error) => `Contrato Inválido`,
    min: (error) => `O valor mínimo é ${error.min}`,
    max: (error) => `O valor máximo é ${error.max}`,
    pattern: (error) => `Formato inválido`,
    fileType: (error) => `O Tipo de arquivo ${error} não é suportado.`,
    imageSize: (error) => `A imagem precisa ter o tamanho menor ou igual a ${error.width}x${error.height}`,
    host: (error) => `Endereço inválido`,
    whitespace: (error) => 'Espaços não são permitidos',
    currency: (error) => `Valor inválido`,
    cep: (error) => `CEP Inválido`,
    data: (error) => `Data Inválida`,
    chassi: (error) => `${error}`,
    placa: (error) => `${error}`,
    cnpjCaepf: (error) => `CNPJ/CAEPF Inválido`,
    nome: (error) => `Nome inválido. Use apenas letras, espaços e acentos`,
}

export const FORM_ERRORS = new InjectionToken('FORM_ERRORS', {
    providedIn: 'root',
    factory: () => defaultErrors
})
